import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { UserIdleService } from 'angular-user-idle';
import { AuthService } from '@auth0/auth0-angular';
import { LOGIN_PATH } from '../../../values/path';
import { ENVIRONMENT_TOKEN } from '../../../values/environment.token';

@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  @ViewChild('Container', { read: ViewContainerRef })
  public _containerRef!: ViewContainerRef;
  private _timeoutDialog!: DialogRef;
  private _environment = inject(ENVIRONMENT_TOKEN);

  constructor(
    private _dialogService: DialogService,
    private _router: Router,
    private _userIdleService: UserIdleService,
    private _authService: AuthService
  ) {}

  ngOnInit() {
    this._userIdleService.startWatching();

    this._userIdleService.onTimerStart().subscribe((time) => {
      if (time === 1) {
        this._timeoutDialog = this._dialogService.open({
          title: '10 Minutes Of Inactivity',
          content:
            '  You have been inactive for 10 minutes. You will be automatically logged out in 2 minutes',
          actions: [
            { text: 'Stay Logged In' },
            { text: 'Logout', themeColor: 'primary' },
          ],
          width: 450,
          height: 200,
          minWidth: 250,
          appendTo: this._containerRef,
        });

        this._timeoutDialog.result.subscribe((result: any) => {
          if (result?.text === 'Logout') {
            this.logout();
          } else if (result?.text === 'Stay Logged In') {
            this.keepOpen();
          }
        });
      } else if (time === 120) {
        this.logout();
      }
    });
  }

  keepOpen() {
    this._userIdleService.stopTimer();
    this._userIdleService.resetTimer();
    this._userIdleService.stopWatching();
    this._userIdleService.startWatching();
  }

  logout() {
    this._timeoutDialog.close();
    this._userIdleService.stopWatching();

    const returnToUrl =
      this._environment.auth0LogoutRedirectUri ||
      `http://localhost:4200/${LOGIN_PATH}`;

    this._authService.logout({
      logoutParams: {
        returnTo: returnToUrl,
      },
    });
  }
}
